import { mergeClassNames } from "@hitechline/reactools";
import { useState, useCallback } from "react";

import styles from "./css/app.module.css";
import { Send } from "./screens/Send";
import { Success } from "./screens/Success";
import { UIContext } from "./UIContext";

export const App = (): JSX.Element => {
  const [isSuccess, setIsSuccess] = useState(false);

  const success = useCallback(() => {
    setIsSuccess(true);
  }, []);

  return (
    <UIContext.Provider value={{ success }}>
      <div className={styles.app}>
        <main className={mergeClassNames("main-container", styles.main)}>
          <header>
            <h1>Formulário de Interesse – Urbano Norte</h1>
          </header>

          <UIContext.Consumer>
            {() => {
              if (isSuccess) return <Success />;
              return <Send />;
            }}
          </UIContext.Consumer>
        </main>

        <footer className={styles.footer}>
          <div>{/* */}</div>

          <section className="padding-x">
            <p>© Todos os direitos reservados - Urbano Norte</p>
            <p className="contact">Desenvolvido por Urbano Labs</p>
          </section>
        </footer>
      </div>
    </UIContext.Provider>
  );
};
